import React from 'react';
import { DatePicker, Menu, Dropdown, Button } from 'antd';
import { CalendarOutlined, DownOutlined } from '@ant-design/icons';
import { ANALYTICS_DATE_PRESETS } from '../../configs/analytics.config';

const { RangePicker } = DatePicker;

const DIVIDER_AFTER = new Set(['Last Year', 'Last 180 Days']);

const AnalyticsDateFilter = ({ dateRange, rangeKey, onPresetChange, onCustomRange }) => {
  const menuItems = [];
  Object.keys(ANALYTICS_DATE_PRESETS).forEach((key) => {
    menuItems.push(
      <Menu.Item key={key} icon={<CalendarOutlined />}>
        {key}
      </Menu.Item>
    );
    if (DIVIDER_AFTER.has(key)) {
      menuItems.push(<Menu.Divider key={`divider-${key}`} />);
    }
  });

  const menu = (
    <Menu onClick={(e) => onPresetChange(e.key)}>
      {menuItems}
    </Menu>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <RangePicker
        className="task-filter-datepicker"
        style={{ width: 400 }}
        value={dateRange}
        onChange={onCustomRange}
        format="MMM D, YYYY"
        allowClear={false}
        suffixIcon={<CalendarOutlined />}
      />
      <Dropdown overlay={menu} trigger={['click']}>
        <Button className="task-filter-select-btn">
          <CalendarOutlined />
          {rangeKey || 'Custom'} <DownOutlined />
        </Button>
      </Dropdown>
    </div>
  );
};

export default AnalyticsDateFilter;
